import {
  Injectable
} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard
  implements CanActivate {

  constructor(
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    const token =
      localStorage.getItem('token');

    const allowedRoles = route.data?.['roles'] as string[];

    if (!this.hasRole(allowedRoles)) {
      this.router.navigate(
        ['/login'],
        {
          queryParams: {
            returnUrl: state.url
          }
        }
      );
      return false;
    }

    if (token) {
      return true;
    }

    this.router.navigate(
      ['/login'],
      {
        queryParams: {
          returnUrl: state.url
        }
      }
    );

    return false;
  }

  getUserRole(): string {
    return sessionStorage.getItem('roleCode')?.toString() || '';
  }

  hasRole(roles: string[]): boolean {
    const userRole = this.getUserRole();

    return roles.some(role => userRole == role);
  }

}